// extracted by mini-css-extract-plugin
export default {"ComplaintsRadio__Lable":"C6QVsd504YpsffCzEbzG","ComplaintsRadio__Input":"OIPpePlMeaKoqTack2A8","ComplaintsRadio__Icon":"AGYNK3PR5iVzm7NySwC8","ComplaintsRadio__Text":"qSaMVSnPrg0Q2m39pUsO"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ComplaintsRadio__Lable\":\"C6QVsd504YpsffCzEbzG\",\"ComplaintsRadio__Input\":\"OIPpePlMeaKoqTack2A8\",\"ComplaintsRadio__Icon\":\"AGYNK3PR5iVzm7NySwC8\",\"ComplaintsRadio__Text\":\"qSaMVSnPrg0Q2m39pUsO\"}";
        // 1786025677546
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  